import { css } from 'aphrodite';
import * as React from 'react';
import { type FirstResponseRow, formatCount, formatDurationMinutes } from './reportsPresentation';
import { reportsStyles as rs } from './styles/reportsStyles';

interface FirstResponseCardProps {
	medianMinutes: number | null;
	measuredCount: number;
	rows: FirstResponseRow[];
	isLoading?: boolean;
}

export const FirstResponseCard: React.FC<FirstResponseCardProps> = ({
	medianMinutes,
	measuredCount,
	rows,
	isLoading,
}) => (
	<section className={css(rs.card)}>
		<div className={css(rs.cardHeader)}>
			<div>
				<h2 className={css(rs.cardTitle)}>First response time</h2>
				<div className={css(rs.cardSubtitle)}>Time to first reply, by bucket</div>
			</div>
		</div>
		{isLoading ? (
			<div className={css(rs.chartLoading)}>Loading…</div>
		) : measuredCount === 0 ? (
			<div className={css(rs.chartEmpty)}>No first replies recorded in this period.</div>
		) : (
			<>
				<div className={css(rs.headline)}>{formatDurationMinutes(medianMinutes)}</div>
				<div className={css(rs.headlineHint)}>Median across {formatCount(measuredCount)} measured conversations</div>
				<ul className={css(rs.barList)}>
					{rows.map(row => (
						<li key={row.key} className={css(rs.barRow)}>
							<span className={css(rs.barRowLabel)}>{row.label}</span>
							<div className={css(rs.barTrack)}>
								<div className={css(rs.barFill)} style={{ width: `${row.widthPercent}%` }} />
							</div>
							<span className={css(rs.barRowValue)}>
								{formatCount(row.count)} · {row.percent}%
							</span>
						</li>
					))}
				</ul>
			</>
		)}
	</section>
);
